export const loggedInRole = JSON.parse(
  sessionStorage.getItem("usrlgndtls")
)?.isAdmin;

export const loggedInId = JSON.parse(
  sessionStorage.getItem("usrlgndtls")
)?.userId;

export const loginSubscriptionID = JSON.parse(
  sessionStorage.getItem("usrlgndtls")
)?.subscriptionId;

export const AdminAccess = sessionStorage.getItem("AdminAccess");
